import { render, staticRenderFns } from "./ProcurementIntegrations.vue?vue&type=template&id=e8e9eca4&scoped=true&"
import script from "./ProcurementIntegrations.vue?vue&type=script&lang=js&"
export * from "./ProcurementIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./ProcurementIntegrations.vue?vue&type=style&index=0&id=e8e9eca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e9eca4",
  null
  
)

export default component.exports